/* eslint-disable react/jsx-no-useless-fragment */
import './index.scss';

const Loader = ({ children, loading }: { children: any; loading: boolean }) => (
  <>
    {loading ? (
      <div className="opaque-loader-wrapper">
        <div className="lds-roller">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    ) : (
      <>{children}</>
    )}
  </>
);
export default Loader;
